import { create } from 'zustand/index';
import { RawUser, UserEntity } from '@entities/User/Types';
import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { MyProfileInfoGateway } from '../../Processes/Gateways/MyProfileInfo/MyProfileInfoGateway';
import { UserModel } from '@entities/User/UserModel';

const myProfileInfoGateway = new MyProfileInfoGateway();
const userModel = new UserModel();

interface State {
    currentUser: UserEntity;
    isMyProfileInfoLoading: boolean;
    fetchMyProfileInfo: () => Promise<ApiResult<RawUser>>;
}

export const useUserInfoViewModel = create<State>((set, get) => ({
    currentUser: userModel,
    isMyProfileInfoLoading: false,

    fetchMyProfileInfo: async () => {
        set({ isMyProfileInfoLoading: true });
        const response = await myProfileInfoGateway.getMyProfileInfo();
        if (response.data) {
            userModel.initialize(response.data);
            set({ currentUser: userModel });
        }
        set({ isMyProfileInfoLoading: false });
        return response;
    },
}));
